/**
 * Build sport team logo / mark URL from blob storage.
 *
 * When the contest sets `style_config.teamAssetFolder` (or League IP defaults
 * apply), paths follow picks-core/{sport}/{folder}/… — same catalog as Admin /
 * Pick'em AssetFolderSelector.
 */
import { resolveTeamMarkUrl } from '@/utils/teamAssetFolder';

/**
 * Returns the team mark URL for a given sport and team code.
 * Falls back to empty string if the sport or team code is unavailable.
 *
 * @param teamCode - 3-letter team abbreviation (e.g. BAL, NYY)
 * @param sport - Sport code (e.g. 'MLB', 'NBA', 'NFL'). Defaults to 'MLB' for backward compatibility.
 */
export function getTeamLogoUrl(
  teamCode: string | null | undefined,
  sport: string | null | undefined = 'MLB'
): string {
  return resolveTeamMarkUrl(teamCode, sport);
}
